import { render } from "./TheCarTypeGenerals.vue?vue&type=template&id=397ed216"
import script from "./TheCarTypeGenerals.vue?vue&type=script&lang=js"
export * from "./TheCarTypeGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__